"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var StepperTheme = function StepperTheme() {
  return {
    styleOverrides: {
      root: {
        display: 'flex',
        padding: 24
      },
      horizontal: {
        flexDirection: 'row',
        alignItems: 'center'
      },
      alternativeLabel: {
        alignItems: 'flex-start'
      }
    }
  };
};

var _default = StepperTheme;
exports["default"] = _default;